import { getLatestScreenPath } from "../commonHelper";
import idb from "../../../helpers/indexedDB";

const { constants } = require("../../../constants");

let logCleverTapEvent = () => {} ;
let createUserProfile = () => {};
let logoutSession = () => {};
let getCommonCTAttributes = () =>{}
try {
	const is_cleverTap_enabled = true;
	if (is_cleverTap_enabled && typeof window != "undefined" && window.clevertap != "undefined") {
		createUserProfile = (body) => {
			const profileObj = {};
			if(body.active_dialing_code){
				profileObj.Phone = body.active_dialing_code + body.phone_number;
				profileObj.Identity = body.active_dialing_code + body.phone_number;
			}
			else{
				profileObj.Phone = "+91" + body.phone_number;
				profileObj.Identity = "+91" + body.phone_number;
			}
			if(body.name){
				profileObj.Name = body.name;
			}
			if(body.mailing_address && body.phone_number){
				let mailID = body.mailing_address === "test@example.com" ? body.phone_number+"@example.com" : body.mailing_address;
				profileObj.Email = mailID;
			}
			if(body.gender){
				profileObj.Gender = body.gender.toLowerCase() === 'male' ? 'M' : 'F';
			}
			if (body && body.hasOwnProperty('phone_number')) {
				window.clevertap.onUserLogin.push({
				"Site": profileObj
			});
			}
		};

		logoutSession = () => {
			try{
				window.clevertap.logout();
			} catch{}
		};
		const isKiosk = () =>{
			if(window.innerWidth>1024 && window.innerHeight > 1366){
				return true;
			}
			return false;
		}
		getCommonCTAttributes = () =>{
			let kioskCtEventData = {}
			try{
				kioskCtEventData = idb.getJSONSync("kioskCtEventData") || {} ;
			} catch(err){}
			const payloadWithCommonAttr = {
				CLIENT_OS: constants.clientOs,
				PLATFORM: isKiosk() ? "KIOSK" : "IPAD",
				STORE: kioskCtEventData.storeID,
				STORE_NAME: kioskCtEventData.storeName,
				STORE_STATUS: kioskCtEventData.storeStatus,
				DEVICE_ID: idb.getItemSync("device_id"),
				SCREEN_PATH: getLatestScreenPath(),
			}
			return payloadWithCommonAttr;
		}
		logCleverTapEvent = (data)=>{
			if(typeof window != "undefined" && window.clevertap && window.clevertap.event){
				const { NAME, PAYLOAD } = data;
				const updatedPayload = {...PAYLOAD, ...getCommonCTAttributes()}
				const updatedName = "KIOSK_" + NAME;
				console.log({NAME,PAYLOAD:updatedPayload, UPDATED_NAME: updatedName, }, "CLEVERTAP DATA")
				if(updatedPayload){
					window.clevertap.event.push(updatedName,updatedPayload);
				}
				else{
					window.clevertap.event.push(updatedName);
				}
			}
		}
	}
} catch (e) {
}
export {
	logCleverTapEvent,
	createUserProfile,
	logoutSession,
	getCommonCTAttributes
  }